import firebase from 'firebase/app'
import 'firebase/firestore'
import 'firebase/auth'

const firebaseConfig = {
  apiKey: 'AIzaSyD4tMcqiGjir5HO38US1W5q5fjfA3d4-Mw',
  authDomain: 'exploroff-web.firebaseapp.com',
  projectId: 'exploroff-web',
  storageBucket: 'exploroff-web.firebasestorage.app',
  messagingSenderId: '880717644846',
  appId: '1:880717644846:web:81b20516daff4673ee0bbf',
  measurementId: 'G-274Y0WER0K',
}

firebase.initializeApp(firebaseConfig)

export default firebase
